export const changeTheme = (primary, secondary) => {
  document.documentElement.style.setProperty('--color-primary', primary);
  document.documentElement.style.setProperty('--color-secondary', secondary);
};

export const getPort = () => 
  process.env.REACT_APP_ENV === 'development'
  ? `:${process.env.REACT_APP_PORT}` : '';